import React from 'react';
import ReactGA from 'react-ga4';
import MediaQuery from 'react-responsive'
import Header from '../../../Header/Header';
import './Home1.scss'

const Home1 = ({sectionCurrently, positionCurrently, setSectionCurrently, setPositionCurrently, Section, Position, responsive}) => {

    const scrollBottom = () =>{
        return sectionCurrently === Section.Section1 && positionCurrently === Position.BOTTOM && !responsive
    }

    const handleRedirect = () => {
        const url = 'https://app.conkarta.com/application';
        window.open(url, '_blank');

        try {
            ReactGA.event({
                category: 'Botón',
                action: 'Clic en botón',
                label: 'Botón Sección "Inicio"',
            });
        } catch (error) {
            console.error('Error al enviar el evento a GA:', error);
        }
    };
    
    const banner1Class = "banner1 fade-in-animation ";
    const banner2Class = "banner2 fade-in-animation ";
    const title1Class = "title-1 fade-slide-in-animation ";
    const text1Class = "text-1 fade-slide-in-animation ";
    const buttonClass = "join-button fade-in-animation ";
    const text2Class = "text-2 fade-slide-in-animation ";
    const text3Class = "text-3 fade-slide-in-animation ";

    const titleColored = "US Credit Card";
    const titleBoldFirst = "For";
    const titleBoldSecond = "Global Citizens";
    const subtitleFirst = "Apply and get approved in minutes.";
    const subtitleSecond = "No SSN / ITIN required.";
    const applyBtnTitle = "Apply now";
    const anualFee = "$300 Annual Fee*";
    const access247first = "24/7 customer service via";
    const access247Bold = "WhatsApp";
    const access247Second = "providing unparalleled service.";

    return (
        <>
            <Header
                sectionCurrently = {sectionCurrently} 
                positionCurrently = {positionCurrently} 
                setSectionCurrently = {setSectionCurrently}
                setPositionCurrently = {setPositionCurrently}
                Section = {Section}
                Position = {Position}
            />
            <MediaQuery minWidth={900}>
                <div className="first-body-section disposition-row justify-between align-center" id = "section-1">
                    <div className = "carousel-track disposition-row justify-start align-center">
                        <img src = "assets/Home/Home1/karta-activities.png" className = { `${banner1Class} ${scrollBottom() ? "move-up-and-fade" : ""}`} alt = "Banner"></img>
                        <img src = "assets/Home/Home1/karta-activities.png" className = { `${banner2Class} ${scrollBottom() ? "move-up-and-fade" : ""}`} alt = "Banner"></img>
                    </div>
                    <div className = "center-section vanish text-center disposition-column justify-start align-center">
                        <p className = { `${title1Class} ${scrollBottom() ? "move-up-and-fade" : ""}`}><b><span style={{color: '#C0A16F'}}>{titleColored}</span></b> {titleBoldFirst}<br/>{titleBoldSecond}</p>
                        <p className = { `${text1Class} ${scrollBottom() ? "move-up-and-fade" : ""}`}>{subtitleFirst} <br/>{subtitleSecond}</p>
                        <button className = { `${buttonClass} ${scrollBottom() ? "move-up-and-fade" : ""}`} onClick={handleRedirect}>{applyBtnTitle}</button>
                        <p className = { `${text2Class} ${scrollBottom() ? "move-up-and-fade" : ""}`}>{anualFee}</p>
                        <img src = "assets/Home/Home1/karta-creditCard-metallic.png" className = "card-img fade-in-animation" alt = "card"></img>
                        <p className = { `${text3Class} ${scrollBottom() ? "move-up-and-fade" : ""}`}>{access247first} <b>{access247Bold}</b><br />{access247Second}</p>
                    </div>
                </div>
            </MediaQuery>
            <MediaQuery minWidth={650} maxWidth={900}>
                <div className="first-body-section-t disposition-row justify-between align-center" id = "section-1">
                    <div className = "carousel-track disposition-row justify-start align-center">
                        <img src = "assets/Home/Home1/karta-activities.png" className = { `${banner1Class} ${scrollBottom() ? "move-up-and-fade" : ""}`} alt = "Banner"></img>
                        <img src = "assets/Home/Home1/karta-activities.png" className = { `${banner2Class} ${scrollBottom() ? "move-up-and-fade" : ""}`} alt = "Banner"></img>
                    </div>
                    <div className = "center-section vanish text-center disposition-column justify-start align-center">
                        <p className = { `${title1Class} ${scrollBottom() ? "move-up-and-fade" : ""}`}><b><span style={{color: '#C0A16F'}}>{titleColored}</span></b> {titleBoldFirst}<br/>{titleBoldSecond}</p>
                        <p className = { `${text1Class} ${scrollBottom() ? "move-up-and-fade" : ""}`}>{subtitleFirst} <br/>{subtitleSecond}</p>
                        <button className = { `${buttonClass} ${scrollBottom() ? "move-up-and-fade" : ""}`} onClick={handleRedirect}>{applyBtnTitle}</button>
                        <p className = { `${text2Class} ${scrollBottom() ? "move-up-and-fade" : ""}`}>{anualFee}</p>
                        <img src = "assets/Home/Home1/karta-creditCard-metallic.png" className = "card-img fade-in-animation" alt = "card"></img>
                        <p className = { `${text3Class} ${scrollBottom() ? "move-up-and-fade" : ""}`}>{access247first} <b>{access247Bold}</b><br />{access247Second}</p>
                    </div>
                </div>
            </MediaQuery>
            <MediaQuery maxWidth={650}>
                <div className="first-body-section-m disposition-column justify-between align-center" id = "section-1">
                    <div className = "center-section disposition-column justify-start align-center">
                        <p className = { `${title1Class} ${scrollBottom() ? "move-up-and-fade" : ""}`}><b><span style={{color: '#C0A16F'}}>{titleColored}</span></b> {titleBoldFirst}<br/>{titleBoldSecond}</p>
                        <p className = { `${text1Class} ${scrollBottom() ? "move-up-and-fade" : ""}`}>{subtitleFirst} <br/>{subtitleSecond}</p>
                        <button className = { `${buttonClass} ${scrollBottom() ? "move-up-and-fade" : ""}`} onClick={handleRedirect}>{applyBtnTitle}</button>
                        <p className = { `${text2Class} ${scrollBottom() ? "move-up-and-fade" : ""}`}>{anualFee}</p>
                        <img src = "assets/Home/Home1/karta-creditCard-metallic.png" className = "card-img fade-in-animation" alt = "card"></img>
                        <p className = { `${text3Class} ${scrollBottom() ? "move-up-and-fade" : ""}`}>{access247first} <b>{access247Bold}</b><br />{access247Second}</p>
                    </div>
                    <div className = "carousel-track disposition-row justify-start align-center">
                        <img src = "assets/Home/Home1/karta-activities.png" className = { `${banner1Class} ${scrollBottom() ? "move-up-and-fade" : ""}`} alt = "Banner"></img>
                    </div>
                </div>
            </MediaQuery>

        </>
    );
};

export default Home1;
